// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { loginStart, loginSuccess, loginFailure } from "../../store/authSlice";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Link,
//   Paper,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useNavigate } from "react-router-dom";
// import { API_BASE_URL } from "../../config";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import { AuthInfoBox } from "../../Components/authSide/authSideComponent";
// import { CaptchaComponent } from "../../Components/captcha/captchaComponent";
// import { useTranslation } from "react-i18next";

// export const RoleBasedLogin = ({ handleShowRegister, handleShowForgot }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const loading = useSelector((state) => state.auth.loading);
//   const { t } = useTranslation();

//   const [roles, setRoles] = useState([]);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     severity: "success",
//     message: "",
//   });
//   const [captchaKey, setCaptchaKey] = useState("");

//   useEffect(() => {
//     fetch(`${API_BASE_URL}/auth/roles/`)
//       .then((res) => res.json())
//       .then((data) => setRoles(data))
//       .catch(() =>
//         setSnackbar({
//           open: true,
//           message: t("roleSignin.errors.fetchRoles"),
//           severity: "error",
//         })
//       );
//   }, [t]);

//   const formik = useFormik({
//     initialValues: { email: "", password: "", role: "", captcha_value: "" },
//     validationSchema: Yup.object({
//       email: Yup.string()
//         .email(t("roleSignin.errors.invalidEmail"))
//         .required(t("roleSignin.errors.emailRequired")),
//       password: Yup.string().required(t("roleSignin.errors.passwordRequired")),
//       role: Yup.string().required(t("roleSignin.errors.roleRequired")),
//       captcha_value: Yup.string().required(t("roleSignin.errors.captchaRequired")),
//     }),
//     onSubmit: async (values) => {
//       dispatch(loginStart());
//       try {
//         const response = await fetch(`${API_BASE_URL}/auth/signin/`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ ...values, captcha_key: captchaKey }),
//         });

//         const data = await response.json();

//         if (
//           !response.ok ||
//           !data.access_token ||
//           !data.refresh_token ||
//           !data.roles
//         ) {
//           throw new Error(data.message || t("roleSignin.errors.defaultFail"));
//         }

//         dispatch(
//           loginSuccess({
//             access_token: data.access_token,
//             refresh_token: data.refresh_token,
//             role: data.roles,
//           })
//         );

//         setSnackbar({
//           open: true,
//           message: t("roleSignin.success"),
//           severity: "success",
//         });
//         setTimeout(() => navigate("/claim-mgmt"), 1000);
//       } catch (err) {
//         dispatch(loginFailure(err.message || t("roleSignin.errors.defaultFail")));
//         setSnackbar({
//           open: true,
//           message: err.message || t("roleSignin.errors.defaultFail"),
//           severity: "error",
//         });
//       }
//     },
//   });

//   const handleCloseSnackbar = (_, reason) => {
//     if (reason === "clickaway") return;
//     setSnackbar((prev) => ({ ...prev, open: false }));
//   };

//   return (
//     <Box sx={{ height: "90vh", display: "flex", flexDirection: "row" }}>
//       {/* Left info box */}
//       <AuthInfoBox />

//       {/* Right side login form */}
//       <Box
//         sx={{
//           maxWidth: { xs: "100%", md: "40%" },
//           minWidth: { xs: "100%", md: "40%" },
//           height: "90vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <Paper
//           elevation={3}
//           sx={{
//             p: 4,
//             width: "100%",
//             maxWidth: 350,
//             maxHeight: "80vh",
//             overflowY: "auto",
//           }}
//         >
//           <Typography
//             variant="h5"
//             fontWeight="bold"
//             gutterBottom
//             textAlign="center"
//           >
//             {t("roleSignin.heading")}
//           </Typography>

//           <Box
//             component="form"
//             onSubmit={formik.handleSubmit}
//             sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//           >
//             <TextField
//               label={t("roleSignin.fields.email")}
//               name="email"
//               type="email"
//               size="small"
//               value={formik.values.email}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.email && Boolean(formik.errors.email)}
//               helperText={formik.touched.email && formik.errors.email}
//               fullWidth
//               required
//             />
//             <TextField
//               label={t("roleSignin.fields.password")}
//               name="password"
//               type="password"
//               size="small"
//               value={formik.values.password}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.password && Boolean(formik.errors.password)}
//               helperText={formik.touched.password && formik.errors.password}
//               fullWidth
//               required
//             />

//             <FormControl
//               fullWidth
//               size="small"
//               required
//               error={formik.touched.role && Boolean(formik.errors.role)}
//             >
//               <InputLabel id="role-label">
//                 {t("roleSignin.fields.role")}
//               </InputLabel>
//               <Select
//                 labelId="role-label"
//                 name="role"
//                 value={formik.values.role}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 label={t("roleSignin.fields.role")}
//               >
//                 {roles.map((role) => (
//                   <MenuItem key={role.id} value={role.name}>
//                     {role.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//               {formik.touched.role && formik.errors.role && (
//                 <Typography variant="caption" color="error">
//                   {formik.errors.role}
//                 </Typography>
//               )}
//             </FormControl>

//             {/* Captcha integration */}
//             <CaptchaComponent
//               onChange={formik.handleChange}
//               setCaptchaKey={setCaptchaKey}
//             />
//             <TextField
//               label={t("roleSignin.fields.captcha")}
//               name="captcha_value"
//               size="small"
//               value={formik.values.captcha_value}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={
//                 formik.touched.captcha_value &&
//                 Boolean(formik.errors.captcha_value)
//               }
//               helperText={
//                 formik.touched.captcha_value && formik.errors.captcha_value
//               }
//               fullWidth
//               required
//             />

//             {/* <Box sx={{ textAlign: "right" }}>
//               <Link
//                 onClick={handleShowForgot}
//                 underline="hover"
//                 sx={{ cursor: "pointer", fontSize: 14 }}
//               >
//                 Forgot password?
//               </Link>
//             </Box> */}

//             <Button
//               type="submit"
//               variant="contained"
//               color="primary"
//               fullWidth
//               disabled={loading}
//               startIcon={loading ? <CircularProgress size={20} /> : null}
//             >
//               {loading
//                 ? t("roleSignin.buttons.loggingIn")
//                 : t("roleSignin.buttons.login")}
//             </Button>
//           </Box>

//           {/* <Typography variant="body2" align="center" sx={{ mt: 2 }}>
//             Don’t have an account?{" "}
//             <Link
//               onClick={handleShowRegister}
//               underline="hover"
//               sx={{ cursor: "pointer" }}
//             >
//               Register
//             </Link>
//           </Typography> */}
//         </Paper>
//       </Box>

//       {/* Snackbar */}
//       <SnackBarComponent
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={handleCloseSnackbar}
//       />
//     </Box>
//   );
// };


import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginStart, loginSuccess, loginFailure } from "../../store/authSlice";
import {
  Box,
  TextField,
  Button,
  Typography,
  Link,
  Paper,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import { AuthInfoBox } from "../../Components/authSide/authSideComponent";
import { CaptchaComponent } from "../../Components/captcha/captchaComponent";
import { useTranslation } from "react-i18next";

// Some roles are stored/returned under an internal name that shouldn't be
// exposed to the user. Map those to their user-facing label here — the
// underlying value sent to the login API is untouched, this only changes
// what's rendered in the dropdown.
const ROLE_DISPLAY_OVERRIDES = {
  super_staff: "case_worker",
};
const getRoleDisplayLabel = (name) => ROLE_DISPLAY_OVERRIDES[name] || name;

export const RoleBasedLogin = ({ handleShowRegister, handleShowForgot }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.auth.loading);
  const { t } = useTranslation();

  const [roles, setRoles] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const [captchaKey, setCaptchaKey] = useState("");

  useEffect(() => {
    fetch(`${API_BASE_URL}/auth/roles/`)
      .then((res) => res.json())
      .then((data) => setRoles(data))
      .catch(() =>
        setSnackbar({
          open: true,
          message: t("roleSignin.errors.fetchRoles"),
          severity: "error",
        })
      );
  }, [t]);

  const formik = useFormik({
    initialValues: { email: "", password: "", role: "", captcha_value: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(t("roleSignin.errors.invalidEmail"))
        .required(t("roleSignin.errors.emailRequired")),
      password: Yup.string().required(t("roleSignin.errors.passwordRequired")),
      role: Yup.string().required(t("roleSignin.errors.roleRequired")),
      captcha_value: Yup.string().required(t("roleSignin.errors.captchaRequired")),
    }),
    // Validate on every keystroke so real-time error/success feedback
    // below actually has something fresh to read on each render.
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values) => {
      dispatch(loginStart());
      try {
        const response = await fetch(`${API_BASE_URL}/auth/signin/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...values, captcha_key: captchaKey }),
        });

        const data = await response.json();

        if (
          !response.ok ||
          !data.access_token ||
          !data.refresh_token ||
          !data.roles
        ) {
          // Backend (UserLoginView) returns errors as { "error": "..." },
          // not "message" — read that first so the snackbar shows the real
          // reason (invalid password, captcha, deactivated account, etc.)
          // instead of always falling back to the generic default text.
          // On serializer validation failures "error" is an object of
          // field -> [messages], not a string, so flatten that case too.
          let backendMessage = data.error;
          if (backendMessage && typeof backendMessage === "object") {
            backendMessage = Object.values(backendMessage).flat().join(" ");
          }
          throw new Error(
            backendMessage || data.message || t("roleSignin.errors.defaultFail")
          );
        }

        dispatch(
          loginSuccess({
            access_token: data.access_token,
            refresh_token: data.refresh_token,
            role: data.roles,
          })
        );

        setSnackbar({
          open: true,
          message: t("roleSignin.success"),
          severity: "success",
        });
        setTimeout(() => navigate("/claim-mgmt"), 1000);
      } catch (err) {
        dispatch(loginFailure(err.message || t("roleSignin.errors.defaultFail")));
        setSnackbar({
          open: true,
          message: err.message || t("roleSignin.errors.defaultFail"),
          severity: "error",
        });
      }
    },
  });

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // Real-time helper: once a field has a value, show its error live as the
  // user types — don't wait for blur/submit. Fields that are still empty
  // stay quiet (no "required" nagging on a fresh form).
  const fieldState = (name) => {
    const value = formik.values[name];
    const hasValue = value !== "" && value !== undefined && value !== null;
    const error = formik.errors[name];
    return {
      showError: hasValue && Boolean(error),
      helperText: hasValue && error ? error : "",
    };
  };

  const emailState = fieldState("email");
  const passwordState = fieldState("password");
  const roleState = fieldState("role");
  const captchaState = fieldState("captcha_value");

  return (
    <Box sx={{ height: "90vh", display: "flex", flexDirection: "row" }}>
      {/* Left info box */}
      <AuthInfoBox />

      {/* Right side login form */}
      <Box
        sx={{
          maxWidth: { xs: "100%", md: "40%" },
          minWidth: { xs: "100%", md: "40%" },
          height: "90vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: "100%",
            maxWidth: 350,
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h5"
            fontWeight="bold"
            gutterBottom
            textAlign="center"
          >
            {t("roleSignin.heading")}
          </Typography>

          <Box
            component="form"
            onSubmit={formik.handleSubmit}
            sx={{ display: "flex", flexDirection: "column", gap: 2 }}
          >
            <TextField
              label={t("roleSignin.fields.email")}
              name="email"
              type="email"
              size="small"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={emailState.showError}
              helperText={emailState.helperText}
              fullWidth
              required
            />
            <TextField
              label={t("roleSignin.fields.password")}
              name="password"
              type="password"
              size="small"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={passwordState.showError}
              helperText={passwordState.helperText}
              fullWidth
              required
            />

            <FormControl
              fullWidth
              size="small"
              required
              error={roleState.showError}
            >
              <InputLabel id="role-label">
                {t("roleSignin.fields.role")}
              </InputLabel>
              <Select
                labelId="role-label"
                name="role"
                value={formik.values.role}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label={t("roleSignin.fields.role")}
              >
                {roles.map((role) => (
                  <MenuItem key={role.id} value={role.name}>
                    {getRoleDisplayLabel(role.name)}
                  </MenuItem>
                ))}
              </Select>
              {roleState.showError && (
                <Typography variant="caption" color="error">
                  {roleState.helperText}
                </Typography>
              )}
            </FormControl>

            {/* Captcha integration */}
            <CaptchaComponent
              onChange={formik.handleChange}
              setCaptchaKey={setCaptchaKey}
            />
            <TextField
              label={t("roleSignin.fields.captcha")}
              name="captcha_value"
              size="small"
              value={formik.values.captcha_value}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={captchaState.showError}
              helperText={captchaState.helperText}
              fullWidth
              required
            />

            {/* <Box sx={{ textAlign: "right" }}>
              <Link
                onClick={handleShowForgot}
                underline="hover"
                sx={{ cursor: "pointer", fontSize: 14 }}
              >
                Forgot password?
              </Link>
            </Box> */}

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : null}
            >
              {loading
                ? t("roleSignin.buttons.loggingIn")
                : t("roleSignin.buttons.login")}
            </Button>
          </Box>

          {/* <Typography variant="body2" align="center" sx={{ mt: 2 }}>
            Don’t have an account?{" "}
            <Link
              onClick={handleShowRegister}
              underline="hover"
              sx={{ cursor: "pointer" }}
            >
              Register
            </Link>
          </Typography> */}
        </Paper>
      </Box>

      {/* Snackbar */}
      <SnackBarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </Box>
  );
};